import {getAvatarUrlForVoice} from '@Panels/ai-voice-panel/components/generated-voice-list/generated-voice-list.library';
import type {GeneratedVoiceItemProps, GeneratedVoiceTileData} from './generated-voice-item.types';

/**
 * `audioUrl` is passed in because the file moves: a fresh generation plays from the AI Voice bucket, a voice saved to
 * the user's uploads from the uploads bucket.
 */
export const getGeneratedVoiceItemProps = (voice: GeneratedVoiceTileData, audioUrl: string): GeneratedVoiceItemProps => {
  return {
    id: `${voice.id}`,
    title: voice.name,
    duration: voice.duration,
    dateLabel: voice.generatedOn,
    source: audioUrl,
    avatarUrl: getAvatarUrlForVoice(voice.idVoice),
  };
};
